<script>
import moment from 'moment'
import {
  rexTextarea
} from '@/components/views/rexField'
import chevronIcon from '@/assets/images/icons/chevron.svg?inline'
import sendMessageIcon from '@/assets/images/icons/send-message.svg?inline'

export default {
  name: 'chat',
  components: {
    rexTextarea,
    chevronIcon,
    sendMessageIcon
  },
  computed: {
    chat() {
      return this.$store.getters['order/getChat']
    },
    isOpened() {
      return this.chat.isOpened || this.$store.getters['order/isChatDefaultOpened']
    }
  },
  methods: {
    toggleChat() {
      this.$store.commit('order/setChat', {
        isOpened: !this.chat.isOpened
      })
    },
    showSenderInfo({ isAuthor, author }, index) {
      let result = false

      if (index && !isAuthor) {
        result = this.chat.messages[index - 1].author.id !== author.id
      }

      return result
    },
    formatDate: date => moment.unix(date).format('DD.MM.YYYY HH:MM'),
    submitForm() {
      const message = this.chat.form.message.trim()

      if (message.length) {
        this.$store.dispatch('order/sendMessage', {
          orderId: this.$route.params.orderId,
          message
        })

        this.$store.commit('order/setChat', {
          isLoading: true
        })
      }
    },
    handleMessageInput(e) {
      if (e.code === 'Enter') {
        if (e.ctrlKey) {
          this.$store.commit('order/setChat', {
            form: {
              message: `${this.chat.form.message}\r\n`
            }
          })
        } else if (this.chat.form.message.trim().length) {
          e.preventDefault()
          this.submitForm()
        }
      }
    }
  },
}
</script>

<template>
  <div class="chat">
    <div
      class="chat__header"
      :class="{
        'chat__header--opened': isOpened
      }"
    >
      Общение по заказу
      <button>
        <chevron-icon
          fill="#fff"
          class="chat__header-toggle-button"
          :class="{
            'chat__header-toggle-button--reverse': !isOpened
          }"
          @click="toggleChat"
        />
      </button>
    </div>
    <div v-if="isOpened">
      <div
        id="orderChatArea"
        class="chat__messages-area"
      >
        <h2
          v-if="chat.isBlocked"
          class="chat__loading-error"
        >
          Произошла ошибка при загрузке чата
        </h2>
        <div
          v-else
          class="chat__messages-wrap"
        >
          <div
            v-for="(message, index) in chat.messages"
            :key="`${message.id}_${index}`"
            class="chat__message"
            :class="{
              'chat__message--from-user': message.isAuthor
            }"
          >
            <div class="chat__message-wrap">
              <img
                v-if="showSenderInfo(message, index)"
                v-lazyload
                src="@/assets/images/default.jpg"
                :data-src="message.author.avatar"
                :alt="message.author.name"
                class="chat__message-author-avatar"
              >
              <div
                class="chat__message-content"
                :class="{
                  'chat__message-content--no-avatar': !showSenderInfo(message, index)
                }"
              >
                <div
                  v-if="showSenderInfo(message, index)"
                  class="chat__message-author-name"
                >
                  {{ message.author.name }}
                </div>
                <div class="chat__message-text">
                  <p>{{ message.text }}</p>
                  <span class="chat__message-sendtime">
                    {{ formatDate(message.createDate) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="!chat.isBlocked"
        class="chat__send-message"
        @keypress="handleMessageInput"
      >
        <form @submit.prevent="submitForm">
          <rex-textarea
            name="message"
            store-module="order"
            getter-name="getServiceField"
            setter-name="updateServiceField"
            target="chat.form.message"
            :show-label="false"
            placeholder="Введите сообщение"
          />
          <button
            v-if="chat.form.message"
            class="chat__send-message-button"
          >
            <send-message-icon
              fill="#fff"
            />
          </button>
          <b-loading
            :is-full-page="false"
            :active="chat.isLoading"
          />
        </form>
      </div>
    </div>
  </div>
</template>
